import styled from 'styled-components';

export const Content = styled.div`
  padding: 0 5px;
  background-color: #ddd;
  border-radius: 5px;
  height: 3px;
`;

export const Thumb = styled.div`
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: #ccc;
  /* border: 1px solid transparent;
  &:hover {
    border: 1px solid #666;
  } */
`;

export const Track = styled.div`
  height: 3px;
  border-radius: 3px;
  background-color: #ddd;
`;
